import { useState } from 'react'
import { FormikErrors } from 'formik'
import DialogUploadValues from '@/types/dialogUploadValues'
import { WIZARD_LAST_STEP } from './wizardSteps'

/** Fields validated before letting the user leave a given step. Agence is
 * pré-remplie et optionnelle dans ce wizard : seuls le nom et le type de
 * déclaration bloquent le passage à l'étape suivante. */
const STEP_FIELDS: (keyof DialogUploadValues)[][] = [
  ['files'],
  ['recordName', 'exportConfiguration'],
]

export const isStepValid = (
  step: number,
  errors: FormikErrors<DialogUploadValues>
): boolean => STEP_FIELDS[step].every((field) => !errors[field])

export function useWizardStep(initialStep: number) {
  const [step, setStep] = useState(initialStep)
  const [maxStep, setMaxStep] = useState(initialStep)
  const [showStepErrors, setShowStepErrors] = useState(false)

  const goToStep = (target: number) => {
    if (target > maxStep) return
    setShowStepErrors(false)
    setStep(target)
  }

  const advance = () => {
    setShowStepErrors(false)
    const next = Math.min(step + 1, WIZARD_LAST_STEP)
    setStep(next)
    setMaxStep((prevMax) => Math.max(prevMax, next))
  }

  const goBack = () => {
    setShowStepErrors(false)
    setStep((prev) => Math.max(prev - 1, 0))
  }

  /** Brings the wizard back to a fresh state, e.g. when the dialog reopens. */
  const reset = (newInitialStep: number) => {
    setShowStepErrors(false)
    setStep(newInitialStep)
    setMaxStep(newInitialStep)
  }

  return {
    step,
    maxStep,
    showStepErrors,
    setShowStepErrors,
    goToStep,
    advance,
    goBack,
    reset,
  }
}
